import React from "react"
import { useDeviceCount } from "../../data/DataProviders/DeviceCountProvider";
import { isRecordFound, useSelectedOrganizationData } from "../../hooks/data-hooks";
import { isDataLoaded, LocationInfo } from "../../types"
import { FlatListItem } from "../FlatListItem/FlatListItem"

export const LocationListItem: React.FC<{ locationData: LocationInfo }> = (props) => {
    const deviceCount = useDeviceCount();
    const selectedOrganization = useSelectedOrganizationData();
    const orgId = isRecordFound(selectedOrganization) ? selectedOrganization.value.id : '';
    const totalDeviceCount: number = isDataLoaded(deviceCount) ? deviceCount.value || 0 : 0
    return (

        <FlatListItem key={props.locationData.locationId}
            item={{
                id: props.locationData.locationId, name: props.locationData.locationName,
                isEditable: true
            }}
            subTitleData={`${props.locationData.siteCount} Sites | ${totalDeviceCount} Total Devices`}
            hasStatus={false}
            navigate={{
                type: 'LocationProfile',
                orgId: orgId, locationId: props.locationData.locationId
            }}>
        </FlatListItem>

    )
}